/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/12/22, 9:21 AM
 *
 */

import { SubscriptionChart } from 'features/members/components/charts/SubscriptionChart';

export default SubscriptionChart;
